import {useCallback, useState} from 'react'

import ConfigurationStorageSwitch from '../../../../../components/ConfigurationStorage/ConfigurationStorageSwitch'
import ConfigurationStorageDialog from '../../../../../components/ConfigurationStorageDialog/ConfigurationStorageDialog'
import {pipelinesApi} from '../../../../../services/pipelinesApi'
import type {NewVcsRootDto, VersionedSettingsDto} from '../../../../../services/pipelinesApi.types'

type Props = {
  vcsRoot: NewVcsRootDto
  savedStoredInRepo?: boolean
  storedInRepo?: boolean
  changeVersionedSettingsHandler: (settings: VersionedSettingsDto) => void
}
function ConfigurationStorageSection({
  vcsRoot,
  savedStoredInRepo,
  storedInRepo,
  changeVersionedSettingsHandler,
}: Props) {
  const [dialogVisible, setDialogVisible] = useState(false)

  const [checkVersionedSettings] = pipelinesApi.endpoints.checkVersionedSettings.useLazyQuery()

  const handleStorageChange = useCallback(
    async (settings: VersionedSettingsDto) => {
      changeVersionedSettingsHandler(settings)
      if (settings.storedInRepo && !savedStoredInRepo && vcsRoot.url) {
        const hasFileInRepo = await checkVersionedSettings({vcsRoot}).unwrap()
        setDialogVisible(hasFileInRepo)
      }
    },
    [changeVersionedSettingsHandler, checkVersionedSettings, savedStoredInRepo, vcsRoot],
  )

  const handleVersionedSettingsChange = useCallback(
    (settings: VersionedSettingsDto) => {
      changeVersionedSettingsHandler(settings)
      setDialogVisible(false)
    },
    [changeVersionedSettingsHandler],
  )

  const onClose = useCallback(() => {
    setDialogVisible(false)
    changeVersionedSettingsHandler({storedInRepo: false})
  }, [changeVersionedSettingsHandler])

  return (
    <>
      <ConfigurationStorageSwitch
        storedInRepo={storedInRepo}
        changeStorageHandler={handleStorageChange}
      />
      <ConfigurationStorageDialog
        isCreationMode={false}
        visible={dialogVisible}
        onConfirm={handleVersionedSettingsChange}
        onClose={onClose}
      />
    </>
  )
}
export default ConfigurationStorageSection
